import { LocationAPI } from '@/clients/location/location.api'
export default {
    namespaced: true,
    state: {
        list: [],
        selected: {},
        selectedLocationProducts: [],
        /**
         * On select location then select product to get details holder
         */
        selectedLocationProductDetailPopup: false,
        selectedLocationProductDetail: {}

    },
    getters: {
        list: state => state.list,
        selected: state => state.selected,
        selectedLocationProducts: state => state.selectedLocationProducts,
        selectedLocationProductDetailPopup: state => state.selectedLocationProductDetailPopup,
        selectedLocationProductDetail: state => state.selectedLocationProductDetail,
        selectedLocationEmail: (state) => {
            if (state.selected && Array.isArray(state.selected.contact_details) && state.selected.contact_details.length > 0) {
                for (let contact of state.selected.contact_details){
                    if (contact.type === 'email') return contact.value
                }

            }
            return null
        }
    },
    mutations: {

        mutateList(state, data) {
            state.list = data
        },
        mutateSelected(state, data) {
            state.selected = data
        },
        mutateSelectedLocationProducts(state, data) {
            state.selectedLocationProducts = data
        },
        mutateSelectedLocationProductDetailPopup(state, data) {
            state.selectedLocationProductDetailPopup = data
        },
        mutateSelectedLocationProductDetail(state, data) {
            state.selectedLocationProductDetail = data
        },
        clearLocationState(state) {
            Object.assign(state, require('./reset/location.json'))
        }
    },
    actions: {
        async setList(context, bId) {
            const { data: { payload: { locations } } } = await LocationAPI.fetch(bId)
            context.commit('mutateList', locations)
        },
        setActiveLocation(context, data) {
            context.commit('mutateSelected', data)
        },
        setSelectedLocationProducts(context, data) {
            context.commit('mutateSelectedLocationProducts', data)
        },
        setSelectedLocationProductDetailPopup(context, data) {
            context.commit('mutateSelectedLocationProductDetailPopup', data)
        },
        setSelectedLocationProductDetail(context, data) {
            context.commit('mutateSelectedLocationProductDetail', data)
        }
    }
}
